module.exports = __webpack_public_path__ + "media/images/area/icon_weather_7-d51d358b68ba27b2fb1da16ad1b80ee3.png";